import React, { useState } from 'react';
import { AlbumModel, stars } from './Data';
import { Album, Title } from './Album';

function getRandomInt(max: number) {
  return Math.floor(Math.random() * Math.floor(max));
}

interface FaceoffResult {
  winner: AlbumModel
  loser: AlbumModel
  left: AlbumModel
  right: AlbumModel
}

/**
 * This function probably has a far nicer boolean simplification but I could
 * not be arsed finding it.
 */
function isDiscrepency(result: FaceoffResult): boolean {
  const { winner, left, right } = result;

  const bothHadRatings = 
    left.rating !== undefined && right.rating !== undefined;

  if (!bothHadRatings) {
    return false;
  }

  const leftWon = left.id === winner.id;
  const rightWon = right.id === winner.id;

  // @ts-ignore
  if (leftWon && left.rating < right.rating) {
    return true;
  }

  // @ts-ignore
  if (rightWon && right.rating < left.rating) {
    return true;
  }

  return false;
}

function Result(props: {
  result: FaceoffResult
}) {
  const { winner, left, right } = props.result;

  const leftWon = left.id === winner.id;

  return (
    <tr>
      <td className={leftWon ? "won" : "lost"}>
        <Title album={left} />
      </td>
      <td>{stars(left.rating)}</td>
      <td>{isDiscrepency(props.result) ? '❌' : '✅'}</td>
      <td>{stars(right.rating)}</td>
      <td className={!leftWon ? "won" : "lost"}>
        <Title album={right} />
      </td>
    </tr>
  )

}

function Results(props: {
  results: FaceoffResult[]
}) {
  return (
    <table>
      <thead>
          <tr>
              <th>Title</th>
              <th style={{ minWidth: '100px' }}>Old Rating</th>
              <th>Check</th>
              <th style={{ minWidth: '100px' }}>Old Rating</th>
              <th>Title</th>
          </tr>
      </thead>
      <tbody>
        {props.results.map(result => <Result result={result} />)}
      </tbody>
    </table>
  )
}


type Fight = [number, number]

function createFight(albums: AlbumModel[]): Fight {
  const left = getRandomInt(albums.length)

  let right
  do {
    // Prevents us from generating the same number.
    right = getRandomInt(albums.length)
  } while (left === right)

  return [left, right]
}

type FightQueue = Fight[]

/**
 * We have to create a queue of albums we want to rate because it takes so long
 * to load album art images.
 */
function createFightQueue(albums: AlbumModel[]): FightQueue  {
  return [
    createFight(albums),
    createFight(albums),
    createFight(albums)
  ]
}

function popPushFightQueue(albums: AlbumModel[], queue: FightQueue) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [head, ...rest] = queue;

  return [...rest, createFight(albums)]
}


export function Faceoff(props: {
  albums: AlbumModel[]
}) {
  const [results, setResults] = useState<FaceoffResult[]>([]);
  const [queue, setQueue] = useState<FightQueue>(createFightQueue(props.albums))
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [head, ...rest] = queue;
  const [leftIndex, rightIndex] = head;

  const leftAlbum = props.albums[leftIndex];
  const rightAlbum = props.albums[rightIndex];

  const leftWins = () => {
      setResults([...results, {
      left: leftAlbum,
      right: rightAlbum,
      winner: leftAlbum,
      loser: rightAlbum
    }]);

    setQueue(popPushFightQueue(props.albums, queue))
  }

  const rightWins = () => {
    setResults([...results, {
      loser: leftAlbum,
      winner: rightAlbum,
      left: leftAlbum,
      right: rightAlbum
    }])

    setQueue(popPushFightQueue(props.albums, queue))
  };


  return <>
    Which album do you prefer?
    <div className="queue">
      {queue.map(([leftIx, rightIx]) => {

        const left = props.albums[leftIx]
        const right = props.albums[rightIx]

        return <div className="fight" key={`${leftIx}-${rightIx}`}>
          <Album key={left.id} album={left} onClick={leftWins} />
          <Album key={right.id} album={right} onClick={rightWins} />
        </div>
      })}
    </div> 
    <Results results={results} />
  </>
}